import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
import { ChevronRight } from 'lucide-react';
export const HeroSection: React.FC = () => {
  return <section className="pt-28 pb-16 px-4 bg-gradient-to-b from-sky-100 to-white overflow-hidden" data-id="element-143">
      <div className="max-w-6xl mx-auto text-center" data-id="element-144">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-blue-900 mb-6 leading-tight tracking-tight" data-id="element-145">
          Mega-Pack Gimnasia Artística <br className="hidden md:block" data-id="element-146" />
          <span className="text-blue-600" data-id="element-147">Infanto-Juvenil</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 mb-10 max-w-3xl mx-auto font-medium" data-id="element-148">
          El sistema completo que te permite preparar clases de gimnasia
          artística profesionales y progresivas en pocos minutos
        </p>

        <div className="relative max-w-4xl mx-auto mb-10 cursor-pointer group" onClick={scrollToOffer} data-id="element-149">
          <div className="absolute inset-0 bg-blue-500 opacity-0 group-hover:opacity-10 rounded-3xl transition-opacity duration-300 blur-xl" data-id="element-150"></div>
          <img src={CONSTANTS.PRODUCT_IMAGE} alt="Mega-Pack Gimnasia Artística Infanto-Juvenil" className="w-full h-auto drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" loading="eager" data-id="element-151" />
        </div>

        <div className="mb-8" data-id="element-152">
          <span className="inline-block bg-yellow-100 text-yellow-800 font-bold px-4 py-2 rounded-full text-lg shadow-sm border border-yellow-200" data-id="element-153">
            🎁 1 Ebook + 5 Bonos Gratuitos
          </span>
        </div>

        <button onClick={scrollToOffer} className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white font-bold text-xl md:text-2xl py-4 px-10 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center mx-auto" data-id="element-154">
          SÍ, QUIERO EL MEGA-PACK AHORA
          <ChevronRight className="ml-2 w-6 h-6" data-id="element-155" />
        </button>

        <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-156">
          Acceso inmediato • Pago único • Garantía de 45 días
        </p>
      </div>
    </section>;
};